import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
// let serverUrl = ("http://localhost:3000")
import i18n from '@plugins/i18n'

export const getters = {
  getSubcategoryFields() {
    return {model: 'repositories_subcategory', 
            label: 'Subcategories',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'description', label: 'Description', type: 'text', sortable: true, required: false },
                { key: 'category', label: 'Categories', type: 'array_model', 
                  model_source: 'Categories', model_route: 'management/masters/categories', 
                  sortable: true, required: true,
                  formatter: (value, key, item) => {
                    return item.category.length}
                }
              ]}
  },
}

export const actions = {
  async fetchSubcategories(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/subcategories/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createSubcategories(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/subcategories/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateSubcategories(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/subcategories/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteSubcategories(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/subcategories/${id}/`)
      .then((response) => {
        return response.data;
      })
  },
}